"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isDoubleArrayOfStrings = exports.isArrayOfStrings = exports.getPreviewKey = exports.getKey = void 0;
const lodash_1 = __importDefault(require("lodash"));
const getKey = (obj, key) => {
    const value = lodash_1.default.get(obj, key);
    // !'' evaluates to false, so check that it's not
    // undefined/null explicitly
    if (value == undefined) {
        throw new Error(`Variable ${key} not found.`);
    }
    return value;
};
exports.getKey = getKey;
const getPreviewKey = (obj, key) => {
    const value = lodash_1.default.get(obj, key);
    return value;
};
exports.getPreviewKey = getPreviewKey;
const isArrayOfStrings = (obj) => {
    if (!Array.isArray(obj)) {
        return false;
    }
    for (let i = 0; i < obj.length; i++) {
        if (typeof obj[i] !== 'string') {
            return false;
        }
    }
    return true;
};
exports.isArrayOfStrings = isArrayOfStrings;
const isDoubleArrayOfStrings = (obj) => {
    if (!Array.isArray(obj)) {
        return false;
    }
    for (let i = 0; i < obj.length; i++) {
        const item = obj[i];
        if (!Array.isArray(item)) {
            break;
        }
        if (!item.every(x => typeof x === 'string')) {
            return false;
        }
    }
    return true;
};
exports.isDoubleArrayOfStrings = isDoubleArrayOfStrings;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaGVscGVycy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9saWIvaGVscGVycy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7QUFBQSxvREFBdUI7QUFFaEIsTUFBTSxNQUFNLEdBQUcsQ0FBQyxHQUFRLEVBQUUsR0FBVyxFQUFPLEVBQUU7SUFDbkQsTUFBTSxLQUFLLEdBQUcsZ0JBQUMsQ0FBQyxHQUFHLENBQUMsR0FBRyxFQUFFLEdBQUcsQ0FBQyxDQUFDO0lBQzlCLGlEQUFpRDtJQUNqRCw0QkFBNEI7SUFDNUIsSUFBSSxLQUFLLElBQUksU0FBUyxFQUFFO1FBQ3RCLE1BQU0sSUFBSSxLQUFLLENBQUUsWUFBWSxHQUFHLGFBQWEsQ0FBQyxDQUFDO0tBQ2hEO0lBQ0QsT0FBTyxLQUFLLENBQUM7QUFDZixDQUFDLENBQUM7QUFSVyxRQUFBLE1BQU0sVUFRakI7QUFFSyxNQUFNLGFBQWEsR0FBRyxDQUFDLEdBQVEsRUFBRSxHQUFXLEVBQU8sRUFBRTtJQUMxRCxNQUFNLEtBQUssR0FBRyxnQkFBQyxDQUFDLEdBQUcsQ0FBQyxHQUFHLEVBQUUsR0FBRyxDQUFDLENBQUM7SUFDOUIsT0FBTyxLQUFLLENBQUM7QUFDZixDQUFDLENBQUM7QUFIVyxRQUFBLGFBQWEsaUJBR3hCO0FBRUssTUFBTSxnQkFBZ0IsR0FBRyxDQUFDLEdBQVEsRUFBVyxFQUFFO0lBQ3BELElBQUksQ0FBQyxLQUFLLENBQUMsT0FBTyxDQUFDLEdBQUcsQ0FBQyxFQUFFO1FBQ3ZCLE9BQU8sS0FBSyxDQUFDO0tBQ2Q7SUFFRCxLQUFLLElBQUksQ0FBQyxHQUFHLENBQUMsRUFBRSxDQUFDLEdBQUcsR0FBRyxDQUFDLE1BQU0sRUFBRSxDQUFDLEVBQUUsRUFBRTtRQUNuQyxJQUFJLE9BQU8sR0FBRyxDQUFDLENBQUMsQ0FBQyxLQUFLLFFBQVEsRUFBRTtZQUM5QixPQUFPLEtBQUssQ0FBQztTQUNkO0tBQ0Y7SUFFRCxPQUFPLElBQUksQ0FBQztBQUNkLENBQUMsQ0FBQztBQVpXLFFBQUEsZ0JBQWdCLG9CQVkzQjtBQUVLLE1BQU0sc0JBQXNCLEdBQUcsQ0FBQyxHQUFRLEVBQVcsRUFBRTtJQUMxRCxJQUFJLENBQUMsS0FBSyxDQUFDLE9BQU8sQ0FBQyxHQUFHLENBQUMsRUFBRTtRQUN2QixPQUFPLEtBQUssQ0FBQTtLQUNiO0lBRUQsS0FBSyxJQUFJLENBQUMsR0FBRyxDQUFDLEVBQUUsQ0FBQyxHQUFHLEdBQUcsQ0FBQyxNQUFNLEVBQUUsQ0FBQyxFQUFFLEVBQUU7UUFDbkMsTUFBTSxJQUFJLEdBQUcsR0FBRyxDQUFDLENBQUMsQ0FBQyxDQUFDO1FBQ3BCLElBQUksQ0FBQyxLQUFLLENBQUMsT0FBTyxDQUFDLElBQUksQ0FBQyxFQUFDO1lBQ3ZCLE1BQU07U0FDUDtRQUVELElBQUksQ0FBQyxJQUFJLENBQUMsS0FBSyxDQUFDLENBQUMsQ0FBQyxFQUFFLENBQUMsT0FBTyxDQUFDLEtBQUssUUFBUSxDQUFDLEVBQUU7WUFDM0MsT0FBTyxLQUFLLENBQUM7U0FDZDtLQUNGO0lBQ0QsT0FBTyxJQUFJLENBQUM7QUFDZCxDQUFDLENBQUM7QUFoQlcsUUFBQSxzQkFBc0IsMEJBZ0JqQyJ9